/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteEventExclusion$Params {

/**
 * Id of a calendar event.
 */
  eventId: string;

/**
 * Id of a resource.
 */
  id: string;
}

export function deleteEventExclusion(http: HttpClient, rootUrl: string, params: DeleteEventExclusion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteEventExclusion.PATH, 'delete');
  if (params) {
    rb.path('eventId', params.eventId, {"style":"simple","explode":false});
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteEventExclusion.PATH = '/api/v1/calendarEvents/{eventId}/exclusions/{id}';
